import proptypes from 'prop-types';

const {
  arrayOf, bool, func, number, oneOf, shape, string
} = proptypes;

const mediaShape = shape({
  id: string,
  url: string,
  type: string,
  altText: string,
  videoStill: string
});

export { mediaShape };

export const staticImageGridPropTypes = {
  /** Media used for the full-width hero tile. Falls back to the first tile when absent. */
  heroMedia: arrayOf(mediaShape),
  /** Media rendered in the two-column grid beneath the hero. */
  tileMedia: arrayOf(mediaShape),
  identifiers: shape({
    brandName: string,
    productLabel: string
  }),
  /** Overrides the default "Product Images" accessible label. */
  overrideData: shape({
    galleryLabel: string,
    brandNameLabel: string
  }),
  hideProductImagesLabel: bool,
  /** Number of tiles rendered before the show-more affordance. */
  visibleTileCount: number,
  /** Renders the chevron affordance at the bottom of the grid. */
  showMoreButton: bool,
  onShowMore: func,
  /** Called with (media, index) when a hero or tile image is clicked, to open the expanded-view overlay. */
  onMediaClick: func,
  heroFetchPriority: oneOf(['high', 'low', 'auto']),
  /** Item the Roomvo "See This In My Room" / "View Virtual Sample" buttons over the hero are for; none without it. */
  itemId: string
};

export const staticImageGridDefaultProps = {
  heroMedia: [],
  tileMedia: [],
  identifiers: null,
  overrideData: null,
  hideProductImagesLabel: false,
  showMoreButton: true,
  onShowMore: null,
  onMediaClick: null,
  heroFetchPriority: 'high',
  itemId: ''
};
